import React, { memo, useState, useCallback, useMemo } from 'react';
import { Icon, Tooltip, Popover, createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import ActionsMenu from './ActionsMenu';
import { useWeb5Context } from 'lib/Web5Context';

import styles from '../styles/index';
const useStyles = createUseStyles(styles, 'MenuOptions');

const MenuOptions = memo(
    ({
        fieldSelector,
        fieldSelectorProps,
        tooltipMenuContent = 'label_table_options_and_export',
    }) => {
        const classes = useStyles();
        const { t } = useWeb5Context();
        const [visible, setVisible] = useState(false);

        const fieldSelectorClasses = classnames(
            classes.fieldSelectorIcon,
            {
                [classes.fieldSelectorIconActive]: visible,
            },
            'fm-grid__field-selector-icon',
        );

        const onToggleMenu = useCallback(() => setVisible(!visible), [visible]);

        if (!fieldSelector) return null;

        const content = (
            <div className={classes.fieldSelectorPopoverContent}>
                <ActionsMenu fieldSelectorProps={fieldSelectorProps} onToggleMenu={onToggleMenu} />
            </div>
        );

        return (
            <div className={classes.fieldSelector}>
                <Popover
                    placement="bottomLeft"
                    className={classes.fieldSelectorPopover}
                    content={content}
                    visible={visible}
                    onVisibleChange={onToggleMenu}
                >
                    <div onClick={onToggleMenu}>
                        <Tooltip placement="right" content={t(tooltipMenuContent)}>
                            <span className={fieldSelectorClasses}>
                                <Icon size="raw" name="moreHoriz" color="currentColor" />
                            </span>
                        </Tooltip>
                    </div>
                </Popover>
            </div>
        );
    },
);

export default MenuOptions;
